import { WidgetAnalyticsService } from './widget-analytics.service';
import * as i0 from "@angular/core";
import * as i1 from "./widget-analytics.service";
export class WidgetAuthService {
    constructor(analyticsService) {
        this.analyticsService = analyticsService;
    }
    /**
     * Validates a developer's widget access.
     */
    authDeveloper(analytic) {
        return this.analyticsService.sendAnalytic(analytic);
    }
    /**
     * Validate a user's widget access.
     */
    authUser(analyticId) {
        return this.analyticsService.getAnalytic(analyticId);
    }
}
WidgetAuthService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function WidgetAuthService_Factory() { return new WidgetAuthService(i0.ɵɵinject(i1.WidgetAnalyticsService)); }, token: WidgetAuthService, providedIn: "root" });
